export const createSseParser = (onEvent) => {
  let buffer = '';
  const processBlock = (block) => {
    const payload = block.split('\n').filter((line) => line.startsWith('data:')).map((line) => line.slice(5).trim()).join('\n');
    if (!payload) return;
    onEvent(JSON.parse(payload));
  };
  return {
    push: (text) => {
      buffer += text.replace(/\r\n/g, '\n');
      let boundary = buffer.indexOf('\n\n');
      while (boundary >= 0) {
        processBlock(buffer.slice(0, boundary));
        buffer = buffer.slice(boundary + 2);
        boundary = buffer.indexOf('\n\n');
      }
    },
    flush: () => {
      if (buffer.trim()) processBlock(buffer);
      buffer = '';
    },
  };
};
